import { React, useState, useEffect, Toast, CustomTable, FormModal, showDeleteOrRestoreMessage, Icon, useUser } from "../../utils/commonImports";
import { formConfigs } from '../../utils/formsConfig';
import { _api } from '../../auth/Api';
import { getPageRights } from "../../utils/accessPages";

const rolesc = [
  { title: "Role Id", dataIndex: "id" },
  { title: "Role Name", dataIndex: "roleName" },
  {
    title: "Status", dataIndex: "isActive",
    render: (isActive) => (
      <span className={`badge ${isActive ? 'bg-success' : 'bg-danger'}`}>
        {isActive ? 'Active' : 'Inactive'}
      </span>
    )
  },
];

const Roles = () => {

  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState({});
  const [roles, setRoles] = useState([]);
  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || [];
  const rights = getPageRights(userPages, 10);

  useEffect(() => {
    _getRoles();
  }, [])

  const _getRoles = async () => {
    try {
      await _api('GET', 'Roles/GetAllActiveRoles', null, (r) => {
        if (r.isSuccess) {
          setRoles(r.data);
        }
      });
    } catch (error) {
      console.log(error)
    }
  };

  const _saveOrUpdateRole = async (data) => {
    let config = { url: '', method: '' };
    if (data && data.id > 0) {
      config.url = `Roles/UpdateRole`;
      data.roleId = data.id;
      delete data.id;
    } else {
      config.url = 'Roles/CreateRole';
    }
    try {
      await _api("POST", config.url, data, (res) => {
        if (res.isSuccess) {
          Toast.fire({ icon: 'success', title: res.message });
          setModalShow(false);
          setData({});
          _getRoles();
        } else {
          Toast.fire({ icon: 'error', title: res.message });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const _deleteRole = async (d) => {
    const isConfirmed = await showDeleteOrRestoreMessage(d?.isActive ? "Delete" : "Restore");
    if (isConfirmed) {
      try {
        await _api('POST', `Roles/DeleteRole`, { roleId: d?.id }, function (res) {
          if (res.isSuccess) {
            Toast.fire({ icon: 'success', title: res.message })
            _getRoles();
          } else {
            Toast.fire({ icon: 'error', title: res.message })
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const launchModal = (data, type) => {
    setData(data);
    setModalShow(type);
  };

  return (
    <>
      {/* <Breadcrumb title="Roles Management" /> */}
      {rights && rights.add && (
        <div className="d-flex justify-content-end" style={{ marginBottom: "10px" }}>
          <button
            onClick={() => launchModal({}, true)}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
          >
            Add Roles <Icon icon="mdi:plus-circle-outline" className="text-md" />
          </button>
        </div>
      )}
      <CustomTable
        columns={rolesc}
        dataSource={roles}
        options={{
          //  pageKey:"Roles Management",
          pageKey: 10,
          withActions: true,
          showEdit: true,
          showDelete: true,
          showView: false,
          loading: false,
          rowKey: "id",
          bordered: true,
          size: "small",
          emptyText: "No Roles found",
        }}
        onEdit={(rowData) => launchModal(rowData, true)}
        onDelete={(d) => _deleteRole(d)}
      />
      <FormModal
        page="Roles"
        size="md"
        config={formConfigs.setup_roles}
        selectedData={data} // selected row
        show={modalShow}
        modalshow={(d, type) => launchModal(d, type)}
        modalsave={(d) => _saveOrUpdateRole(d)}
      />
    </>
  )
}

export default Roles